<script lang="ts" setup>
defineProps<{
  code?: string
}>()

const emit = defineEmits<{
  (e: 'retry'): void
}>()
</script>

<template>
  <p class="turnstile-error" role="alert">
    <v-icon icon="mdi-alert-circle-outline" size="16" />
    {{ $t('auth.turnstileError') }}
    <template v-if="code">
      {{ $t('auth.turnstileErrorCode', { code }) }}
    </template>
    <button type="button" class="turnstile-retry" @click="emit('retry')">
      {{ $t('auth.turnstileRetry') }}
    </button>
  </p>
</template>

<style lang="scss" scoped>
.turnstile-error {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 0.8rem;
  color: #ff8a80;
  text-align: center;
}

.turnstile-retry {
  color: inherit;
  font-weight: 600;
  text-decoration: underline;
}
</style>
